<section class="float-menu" [ngClass]="showMobileMenu ? 'opened' : ''">
  <a
    [routerLink]="[]"
    (click)="toggleMobileMenu()"
    class="close-menu"
    [ngClass]="showMobileMenu ? 'is-active' : ''"
    >X</a
  >
  <div
    class="top d-flex align-items-center justify-content-between flex-row flex-wrap"
  >
    <div class="d-none d-sm-inline-block logo internal-logo">
      <a routerLink="/"
        ><img src="{{ cdnHost }}/icon/mainlogo.svg" alt="Logo" />
      </a>
    </div>
    <div><a class="locations-link" routerLink="/locations">Locations</a></div>
    <div>
      <div class="search-box">
        <input
          type="text"
          name="zipcode"
          (keyup.enter)="handleLocationsSearch()"
          [formControl]="zipcode"
          placeholder="Enter ZIP code"
          id="zipcode521"
          pattern="[0-9]{5}"
          required="required"
          aria-label="Enter Five Digit Zip Code"
          title="Five digit zip code"
        />
        <button type="submit" (click)="handleLocationsSearch()"></button>
      </div>
    </div>
  </div>
  <div class="inside">
    <ul class="list-unstyled mb-4 menu">
      <li class="nav-item">
        <a class="nav-link" routerLink="{{ whyMembershipLink }}"
          >Why Membership?</a
        >
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="{{ whyQQLink }}">Why Quick Quack?</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="{{ FAQsLink }}">FAQs</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="{{ blogLink }}">Blog</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="{{ careerLink }}">Careers</a>
      </li>
      <li *ngIf="enableFriendBuy$ | async" class="nav-item">
        <a class="nav-link" routerLink="/refer">Refer-A-Friend</a>
      </li>
    </ul>
    <div class="bottom">
      <div class="row gx-4">
        <div class="col-6">
          <div class="title support">Support</div>
          <ul class="list-unstyled mb-0">
            <li class="py-1"><a href="{{ FAQsLink }}">FAQs</a></li>
            <li class="py-1">
              <a href="mailto:info@DontDriveDirty.com">{{ email }}</a>
            </li>
            <li class="py-1">
              <a href="tel:888-772-2792">Phone: 888-772-2792</a>
            </li>
          </ul>
        </div>
        <div class="col-6">
          <div class="title signin">
            <span class="color-orange">myQQ</span> Sign In
          </div>
          <ul class="list-unstyled mb-0">
            <li class="py-1">
              <a [routerLink]="[]" (click)="handleLogin()" id="login-btn"
                >My Account</a
              >
            </li>
            <li class="py-1">
              <a
                [routerLink]="[]"
                (click)="handleRegister()"
                data-cy="register-btn"
                >Create an Account</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
<header>
  <div class="container wider h-100">
    <div
      class="d-flex h-100 justify-content-center justify-content-lg-between align-items-lg-center flex-column flex-lg-row"
    >
      <div class="logo">
        <a routerLink="/"
          ><img
            src="{{ cdnHost }}/icon/mainlogo.svg"
            alt="Quick Quack CAR WASH Logo"
        /></a>
      </div>
      <div class="details">
        <div
          class="top d-none d-lg-flex justify-content-end flex-row flex-wrap align-items-center"
        >
          <div class="me-4">
            <a class="locations-link" routerLink="/locations" target="_self"
              >Locations</a
            >
          </div>
          <div class="me-4 me-lg-5">
            <div class="search-box">
              <input
                type="text"
                name="zipcode"
                placeholder="Enter ZIP code"
                id="zipcode1"
                pattern="[0-9]{5}"
                required="required"
                aria-label="Enter Five Digit Zip Code"
                title="Five digit zip code"
                (keyup.enter)="handleLocationsSearch()"
                [formControl]="zipcode"
              />
              <button type="submit" (click)="handleLocationsSearch()"></button>
            </div>
          </div>
          <div>
            <ul class="list-inline mb-0 menus">
              <li class="list-inline-item">
                <div class="dropdown">
                  <a
                    [routerLink]="[]"
                    (click)="toggleSupportMenu()"
                    [ngClass]="showSupportMenu ? 'show' : ''"
                    class="dropdown-toggle"
                    id="dropdownMenuButton1"
                    aria-label="Support"
                    aria-expanded="true"
                    >Support</a
                  >
                  <ul
                    class="dropdown-menu dropdown-menu-end"
                    [ngClass]="showSupportMenu ? 'show' : ''"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <a class="dropdown-item" routerLink="{{ FAQsLink }}"
                        >FAQs</a
                      >
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        href="mailto:info@DontDriveDirty.com"
                        >email</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="tel:888-772-2792"
                        >Phone: 888-772-2792</a
                      >
                    </li>
                  </ul>
                </div>
              </li>
              <li class="list-inline-item">
                <div class="dropdown">
                  <a
                    [routerLink]="[]"
                    (click)="toggleMyQQMenu()"
                    [ngClass]="showMyQQMenu ? 'show' : ''"
                    class="dropdown-toggle"
                    id="dropdownMenuButton1"
                    aria-label="myQQ Sign In"
                    ><span class="color-orange">myQQ</span> Sign In</a
                  >
                  <ul
                    class="dropdown-menu dropdown-menu-end"
                    aria-labelledby="dropdownMenuButton1"
                    [ngClass]="showMyQQMenu ? 'show' : ''"
                  >
                    <li>
                      <a
                        class="dropdown-item"
                        [routerLink]="[]"
                        (click)="handleLogin()"
                        id="login-btn"
                        >My Account</a
                      >
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        [routerLink]="[]"
                        (click)="handleRegister()"
                        data-cy="register-btn"
                        >Create an Account</a
                      >
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="mobile-top">
          <ul class="list-inline mb-0">
            <li class="list-inline-item">
              <a class="locations-link" routerLink="/locations" target="_self"
                >Locations</a
              >
            </li>
          </ul>
        </div>
        <div class="navigation text-end">
          <div
            class="menu d-block d-lg-flex align-items-center justify-content-end"
          >
            <nav class="navbar navbar-expand-lg">
              <button
                class="navbar-toggler d-block d-lg-none hamburger hamburger--collapse"
                (click)="toggleMobileMenu()"
                [ngClass]="this.showMobileMenu ? 'collapsed' : ''"
                type="button"
                data-cy="menu-btn"
                aria-label="Toggle navigation"
              >
                <span class="hamburger-box">
                  <span class="hamburger-inner"></span>
                </span>
              </button>
              <div
                class="collapse navbar-collapse d-none"
                id="navbarTogglerDemo01"
                [ngClass]="this.showMobileMenu ? '' : 'show'"
              >
                <ul class="navbar-nav mr-auto align-items-center">
                  <li class="nav-item">
                    <a class="nav-link" routerLink="{{ whyMembershipLink }}"
                      >Why Membership?</a
                    >
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" routerLink="{{ whyQQLink }}"
                      >Why Quick Quack?</a
                    >
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" routerLink="{{ FAQsLink }}">FAQs</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="{{ blogLink }}">Blog</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" routerLink="{{ careerLink }}"
                      >Careers</a
                    >
                  </li>
                  <li *ngIf="enableFriendBuy$ | async" class="nav-item">
                    <a class="nav-link" routerLink="/refer">Refer-A-Friend</a>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
